import { render } from "./FaceCountDown.vue?vue&type=template&id=ddca9514&scoped=true"
import script from "./FaceCountDown.vue?vue&type=script&lang=js"
export * from "./FaceCountDown.vue?vue&type=script&lang=js"

import "./FaceCountDown.vue?vue&type=style&index=0&id=ddca9514&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ddca9514"

export default script